module.exports = __webpack_public_path__ + "static/the-day-the-crayons-quit-372c366a7cac24f5efa09e0153e61a53.jpg";